import { jsx, jsxs } from 'react/jsx-runtime';
import { QuickTipIcon } from '@iris/react-icons/QuickTipIcon';
import { Card } from '../Card/Card.esm.js';
import quickTipStyles from './QuickTip.styles.esm.js';

const QuickTip = ({ inverse = false, body = "", }) => {
    const title = "quick tip";
    const { quickTipContainer: quickTipContainerClasses, title: titleClasses, body: bodyClasses, icon: iconClasses, content: contentClasses, } = quickTipStyles({ inverse });
    return (jsx(Card, { variant: "subtle", inverse: inverse, children: jsxs(Card.Content, { className: quickTipContainerClasses(), children: [jsx("div", { className: iconClasses(), children: jsx(QuickTipIcon, {}) }), jsxs("div", { className: contentClasses(), children: [jsx("div", { className: titleClasses(), children: title }), jsx("div", { className: bodyClasses(), children: body })] })] }) }));
};
QuickTip.displayName = "QuickTip";

export { QuickTip };
